import FAQMetaHead from "component/meta-header/FAQMetaHead";
import Head from "next/head";
import { useRouter } from "next/router";
import VideosMetaData from "component/meta-header/VideosMetaData";
import BreadcrumbsMetaHead from "../../../component/meta-header/BreadcrumbsMetaHead";
import { getThumbImagePath } from "../../../util/helper/getThumbImagePath";

function MetaHead(props: any) {
  const {
    keywords = [], keywordsV2 = "", title, description = "",
    bannerImageUrl, pageList = [], bannerImages, breadCrumbsList,
    contentIds, robots, videos,
  } = props || {};

  const router = useRouter();
  const { pathname } = router.query;

  const meta = {
    title: title || pathname,
    image: bannerImageUrl,
    description,
    meta: {
      robots: "all",
    },
    keywords: keywordsV2 || keywords,
  };

  const itemListElement = pageList.map((product: any, position: any) => {
    const { canonicalUrl, description: pDesc, thumbnail } = product;
    return {
      "@type": "ListItem",
      position,
      url: `https://partsavatar.ca${canonicalUrl}`,
      name: pDesc,
      description: pDesc,
      image: getThumbImagePath(thumbnail),
    };
  });
  const microdata = {
    "@context": "http://schema.org/",
    "@type": "CollectionPage",
    mainEntity: {
      "@type": "ItemList",
      itemListElement,
      numberOfItems: pageList.length,
    },
  };

  const url = `https://partsavatar.ca/${pathname}`;
  const metaImage = bannerImages?.desktopImage || meta.image;
  return (
    <>

      <Head>

        <title>{meta.title}</title>

        <meta name="facebook-domain-verification" content="82cgyip0cz3a7igt87rjow5o8bf9th" />
        <meta name="description" content={meta.description} />

        <meta name="keywords" content={meta.keywords} />

        <meta name="robots" content={robots || meta.meta.robots} />

        <link rel="canonical" href={url} />

        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(microdata) }}
        />

        <meta property="og:title" content={meta.title} />

        <meta property="og:description" content={meta.description} />

        <meta property="og:type" content="product.group" />

        <meta property="og:url" content={url} />

        <meta property="og:site_name" content="PartsAvatar.ca" />

        <meta property="og:image" content={meta.image} />

        <meta name="twitter:card" content="summary_large_image" />

        <meta name="twitter:title" content={meta.title} />

        <meta name="twitter:description" content={meta.description} />

        <meta name="twitter:image" content={metaImage} />

        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              "@context": "http://schema.org",
              "@type": "WebPage",
              primaryImageOfPage: {
                "@type": "ImageObject",
                url: bannerImageUrl,
              },
            }),
          }}
        />
      </Head>

      <BreadcrumbsMetaHead {...{ breadCrumbList: breadCrumbsList }} />
      {contentIds && (
        <FAQMetaHead contentIds={contentIds} />
      )}
      <VideosMetaData videos={videos} />

    </>
  );
}

export default MetaHead;
